"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDhsBackgroundCheckStatusDto = instanceOfDhsBackgroundCheckStatusDto;
exports.DhsBackgroundCheckStatusDtoFromJSON = DhsBackgroundCheckStatusDtoFromJSON;
exports.DhsBackgroundCheckStatusDtoFromJSONTyped = DhsBackgroundCheckStatusDtoFromJSONTyped;
exports.DhsBackgroundCheckStatusDtoToJSON = DhsBackgroundCheckStatusDtoToJSON;
exports.DhsBackgroundCheckStatusDtoToJSONTyped = DhsBackgroundCheckStatusDtoToJSONTyped;
const DhsBackgroundCheckStatus_1 = require("./DhsBackgroundCheckStatus");
/**
 * Check if a given object implements the DhsBackgroundCheckStatusDto interface.
 */
function instanceOfDhsBackgroundCheckStatusDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('fingerprintedAt' in value) || value['fingerprintedAt'] === undefined)
        return false;
    return true;
}
function DhsBackgroundCheckStatusDtoFromJSON(json) {
    return DhsBackgroundCheckStatusDtoFromJSONTyped(json, false);
}
function DhsBackgroundCheckStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, DhsBackgroundCheckStatus_1.DhsBackgroundCheckStatusFromJSON)(json['status']),
        'fingerprintedAt': (json['fingerprintedAt'] == null ? null : new Date(json['fingerprintedAt'])),
    };
}
function DhsBackgroundCheckStatusDtoToJSON(json) {
    return DhsBackgroundCheckStatusDtoToJSONTyped(json, false);
}
function DhsBackgroundCheckStatusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, DhsBackgroundCheckStatus_1.DhsBackgroundCheckStatusToJSON)(value['status']),
        'fingerprintedAt': (value['fingerprintedAt'] == null ? null : value['fingerprintedAt'].toISOString()),
    };
}
//# sourceMappingURL=DhsBackgroundCheckStatusDto.js.map